import * as React from 'react';
import PropTypes from "prop-types";

import { Row, Col, Input, Button } from 'reactstrap';

export class CarreraConsulta extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            carreras: props.carreraOptions, carrerasEtiqueta: props.carrerasLabel, anios: props.anioOptions, terminos: props.terminoOptions,
            carrera: props.carreraValue, anio: props.aniosValue, termino: props.terminosValue, apellidos: "", nombres: ""
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleDocenteChange = this.handleDocenteChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange = event => {
        this.setState({ apellidos: "", nombres: "" });
        this.props.onInputChange(event);
    }

    handleDocenteChange = event => {
        let name = event.target.name;
        let value = event.target.value;
        if (name == "apellidos") {
            this.setState({ apellidos: value });
        }
        else if (name == "nombres") {
            this.setState({ nombres: value });
        }
    }

    handleSubmit = event => {
        event.preventDefault();
        this.props.handleDocenteSubmit(this.state.apellidos, this.state.nombres);
    }

    render() {
        return (
            <div>
                <form name="consulta" onSubmit={this.handleSubmit}>
                    <Row className="form-group">
                        <Col md={1} className="control-label-container">
                            <label className="control-label" htmlFor="carrera">Carrera:</label>
                        </Col>
                        <Col md={4} className="w-100">
                            <Input
                                type="select"
                                placeholder="Seleccionar una carrera"
                                name="carrera"
                                id="carrera"
                                value={this.props.carreraValue}
                                onChange={this.handleChange}
                            >
                                {this.props.carreraOptions.map((carrera, idx) => <option key={idx} value={carrera}>{this.props.carrerasLabel[idx]}</option>)}
                            </Input>
                        </Col>
                        {this.props.anioOptions && this.props.anioOptions.length > 0 ?
                            <>
                                <Col md={1} className="control-label-container">
                                    <label className="control-label" htmlFor="anio">Año:</label>
                                </Col>
                                <Col md={2}>
                                    <Input
                                        type="select"
                                        value={this.props.anioValue}
                                        placeholder="Año"
                                        name="anio"
                                        id="anio"
                                        onChange={this.handleChange}>
                                        {this.props.anioOptions.map((a, idx) => <option key={idx} value={a}>{a}</option>)}
                                    </Input>
                                </Col>
                            </>
                            : ''}
                        {this.props.terminoOptions && this.props.terminoOptions.length > 0 ?
                            <>
                                <Col md={1} className="control-label-container">
                                    <label className="control-label" htmlFor="termino">Término:</label>
                                </Col>
                                <Col md={2} className="w-100">
                                    <Input
                                        type="select"
                                        name="termino"
                                        value={this.props.terminoValue}
                                        onChange={this.handleChange}>
                                        {this.props.terminoOptions.map((t, idx) => <option key={idx} value={t}> {t}</option>)}
                                    </Input>
                                </Col>
                            </>
                            : ''}
                    </Row>
                    <Row key={0} className="form-group">
                        <Col md={1} className="control-label-container">
                            <label className="control-label" htmlFor="apellidos">Apellidos:</label>
                        </Col>
                        <Col md={3} className="w-100">
                            <Input
                                type="text"
                                placeholder="Apellidos"
                                name="apellidos"
                                id="apellidos"
                                value={this.state.apellidos}
                                onChange={this.handleDocenteChange}
                                maxLength={30}
                            >
                            </Input>
                        </Col>
                        <Col md={1} className="control-label-container">
                            <label className="control-label" htmlFor="nombres">Nombres:</label>
                        </Col>
                        <Col md={3} className="w-100">
                            <Input
                                type="text"
                                placeholder="Nombres"
                                name="nombres"
                                id="nombres"
                                value={this.state.nombres}
                                onChange={this.handleDocenteChange}
                                maxLength={30}
                            >
                            </Input>
                        </Col>
                        <Col md={4}><Button type="submit">Buscar docente</Button></Col>
                    </Row>
                </form>
            </div>
        );
    }
}

CarreraConsulta.propTypes = {
    carrerasOptions: PropTypes.array,
    carrerasLabel: PropTypes.array,
    carrerasValue: PropTypes.any,
    aniosOptions: PropTypes.array,
    aniosValue: PropTypes.any,
    terminosOption: PropTypes.any,
    terminosValue: PropTypes.any,
    onInputChange: PropTypes.func,
};

